export default "__VITE_ASSET__BJlmgKi6__"